import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, Trash2, Check, Loader2, Reply } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { PageTitle } from "@/components/admin/AdminLayout";

export default function Messages() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/admin/messages").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const mark = async (m) => {
    await api.patch(`/admin/messages/${m.id}`, { read: !m.read });
    load();
  };
  const remove = async (m) => {
    if (!window.confirm("Eliminare questo messaggio?")) return;
    try {
      await api.delete(`/admin/messages/${m.id}`);
      toast.success("Messaggio eliminato");
      load();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  return (
    <div data-testid="admin-messages">
      <PageTitle title="Messaggi" subtitle="Richieste ricevute dal modulo contatti del sito (inoltrate anche via email)" />
      {!items ? <Loader2 className="h-6 w-6 animate-spin text-[#E50914]" /> : items.length === 0 ? (
        <p className="bg-white border border-slate-200 p-10 text-center text-slate-500" data-testid="messages-empty">Nessun messaggio ricevuto.</p>
      ) : (
        <div className="space-y-3">
          {items.map((m) => (
            <article key={m.id} className={`bg-white border p-5 ${m.read ? "border-slate-200" : "border-l-4 border-l-[#E50914] border-slate-200"}`} data-testid={`message-${m.id}`}>
              <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-3">
                <div className="min-w-0">
                  <h3 className="font-bold text-slate-900">{m.subject}</h3>
                  <p className="text-sm text-slate-600">{m.name} · <span className="break-all">{m.email}</span>{m.phone && ` · ${m.phone}`}</p>
                  <p className="text-xs text-slate-400 font-mono mt-1">{fmtDateTime(m.created_at)}</p>
                </div>
                <div className="flex gap-2 shrink-0">
                  <Button asChild size="sm" variant="outline" className="rounded-none"><a href={`mailto:${m.email}?subject=${encodeURIComponent(`Re: ${m.subject}`)}`} data-testid={`message-reply-${m.id}`}><Reply className="h-4 w-4 mr-1" /> Rispondi</a></Button>
                  <Button size="sm" variant="outline" className="rounded-none" onClick={() => mark(m)} data-testid={`message-toggle-read-${m.id}`}>{m.read ? <Mail className="h-4 w-4" /> : <Check className="h-4 w-4" />}</Button>
                  <Button size="sm" variant="outline" className="rounded-none text-red-600" onClick={() => remove(m)} data-testid={`message-delete-${m.id}`}><Trash2 className="h-4 w-4" /></Button>
                </div>
              </div>
              <p className="mt-3 text-sm text-slate-700 whitespace-pre-line">{m.message}</p>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
